"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var MoneyModel = /** @class */ (function () {
    function MoneyModel(amount, currencyId) {
        this.amount = amount;
        this.currencyId = currencyId;
    }
    return MoneyModel;
}());
exports.MoneyModel = MoneyModel;
function compareMoney(first, second) {
    if (lodash_1.isNil(first) || lodash_1.isNil(second)) {
        return lodash_1.isNil(first) && lodash_1.isNil(second);
    }
    return (first.amount === second.amount && first.currencyId === second.currencyId);
}
exports.compareMoney = compareMoney;
function isMoneyNil(money) {
    return lodash_1.isNil(money) || (lodash_1.isNil(money.amount) && lodash_1.isNil(money.currencyId));
}
exports.isMoneyNil = isMoneyNil;
//# sourceMappingURL=money.model.js.map